<template>
  <div class="research">
    <indexTitle>
        <template v-slot:title>
            研究方向
        </template>
        <template v-slot:eng>
            Research Direction
        </template>
    </indexTitle>
    <div class="yjfx-swiper">

        <div class="swiper-container yjfx-img">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in directionList" :key="index" :class="{ 'swiper-slide-active': currentIndex === index }">
                <div class="img-box">
                    <img :src="$baseUrl + item.imageUrl">
                </div>
                <div class="yjfx-txt">
                  <img src="@/assets/yjfxlogo.png" alt="">
                  <h1>{{item.title}}</h1>
                  <div class="desc markdown-body" v-html="item.renderedDescription"></div>
                </div>
            </div>
          </div>
        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>

        <div class="swiper-container yjfx-info" @mouseenter="pauseAutoplay" @mouseleave="clearHover">
          <div class="swiper-wrapper fix" style="transition-duration: 0ms;">
            <div
              class="swiper-slide"
              v-for="(item, index) in directionList"
              :key="index"
              :class="{ 'swiper-slide-active': currentIndex === index, 'is-hovered': hoverIndex === index }"
              @mouseenter="hoverDirection(index)"
              @click="goToResearch(item.title)">
              <div class="img-box">
                <div class="icon"></div>
                <p>{{item.title}}</p>
              </div>
            </div>
          </div>
        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>

    </div>
  </div>
</template>

<script>
import { getHomeResearchDirectionList } from '@/api/research.js'
import { renderMarkdown } from '@/utils/markdown.js'

export default {
  name: 'indexResearch',
  data () {
    return {
      directionList: [],
      currentIndex: 0,
      hoverIndex: null,
      isHovering: false,
      autoplayTimer: null,
      hoverSwitchTimer: null
    }
  },
  mounted () {
    this.fetchDirectionData()
  },
  beforeDestroy () {
    this.pauseAutoplay()
    this.clearHoverSwitchTimer()
  },
  methods: {
    async fetchDirectionData () {
      try {
        const res = await getHomeResearchDirectionList()
        if (res?.code === 1 && res.data && res.data.rows) {
          this.directionList = res.data.rows.slice(0, 3).map(item => {
            // 只取 markdown 第三段（按空行分隔）
            const paragraphs = (item.description || '').split(/\n\n+/)
            const third = paragraphs.length >= 3 ? paragraphs[2] : (paragraphs[paragraphs.length - 1] || '')
            return {
              ...item,
              renderedDescription: renderMarkdown(third, this.$baseUrl)
            }
          })
          this.startAutoplay()
        }
      } catch (err) {
        console.error('获取首页研究方向失败:', err)
      }
    },
    setSlideIndex (index) {
      const total = this.directionList.length
      if (!total) return
      this.currentIndex = (index + total) % total
    },
    nextSlide () {
      if (this.isHovering) return
      this.setSlideIndex(this.currentIndex + 1)
    },
    goToSlide (index) {
      this.setSlideIndex(index)
      if (!this.isHovering) this.startAutoplay()
    },
    goToResearch (category) {
      this.$router.push({
        path: '/research',
        query: { type: 'yjfx', subtitle: 'kxyj', cat: category }
      })
    },
    hoverDirection (index) {
      this.isHovering = true
      this.hoverIndex = index
      this.pauseAutoplay()
      this.clearHoverSwitchTimer()
      this.hoverSwitchTimer = setTimeout(() => {
        this.setSlideIndex(index)
        this.hoverSwitchTimer = null
      }, 140)
    },
    clearHover () {
      this.isHovering = false
      this.hoverIndex = null
      this.clearHoverSwitchTimer()
      this.startAutoplay()
    },
    clearHoverSwitchTimer () {
      if (this.hoverSwitchTimer) {
        clearTimeout(this.hoverSwitchTimer)
        this.hoverSwitchTimer = null
      }
    },
    pauseAutoplay () {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer)
        this.autoplayTimer = null
      }
    },
    startAutoplay () {
      this.pauseAutoplay()
      if (this.directionList.length <= 1 || this.isHovering) return
      this.autoplayTimer = setInterval(() => {
        this.nextSlide()
      }, 3000)
    }
  }
}
</script>

<style lang="less">
.research{
    height:560px;
    padding:20px 107px 20px 107px;
    background: #fff url(@/assets/xiantiao.webp) no-repeat center bottom;
    background-size: 100% 64%;
    .yjfx-swiper {
      position: relative;
      margin-top: -70px;
      padding-bottom: 48px;
      .swiper-container {
        width: 100%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        z-index: 1;
        .swiper-wrapper {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 1;
          display: flex;
          transition-property: transform;
          box-sizing: content-box;
          &>.swiper-slide {
            flex-shrink: 0;
            width: 1045px;
            height: 100%;
            position: relative;
            transition-property: transform;

          }
        }
      }
      .yjfx-img{
        .swiper-slide {
          display: none !important;
        }
        .swiper-slide-active {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) minmax(280px, 400px);
          gap: 40px;
          align-items: center;
          min-height: 246px;
          animation: researchSlideIn 0.76s cubic-bezier(0.22, 1, 0.36, 1) both;
        }
        .img-box {
          float: none;
          width: 400px;
          height: 266px;
          border-radius: var(--radius-md);
          margin: 0;
          overflow: hidden;
          justify-self: end;
          box-shadow: 0 18px 38px rgba(10, 54, 92, 0.14);
          &>img{
                width: 100%;
                height: 100%;
                object-fit: cover;
          }
        }
        .yjfx-txt {
            overflow: hidden;
            min-width: 0;
            &>img {
                  display: block;
                  width: 38px;
                  height: 38px;
                  margin-bottom: 12px;
            }
            h1{
                  font-size: 22px;
                  color: #333333;
                  line-height: 30px;
                  position: relative;
                  padding-bottom: 15px;
                  margin-bottom: 12px;
            }
            .desc{
                  font-size: 13px;
                  color: #666666;
                  line-height: 23px;
                  text-align: justify;
                  word-break: break-word;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 4;
                  -webkit-box-orient: vertical;
                  max-height: 92px;
            }
        }
      }
      .yjfx-info {
        position: relative;
        left: auto;
        bottom: auto;
        width: calc(100% - 96px);
        height: auto;
        margin: 10px 0 -8px -6px;
        padding: 10px 6px 18px;
        overflow: visible;
        .swiper-wrapper {
          -webkit-box-align: end;
          -ms-flex-align: end;
          align-items: center;
          gap: 8px;
          &>.swiper-slide {
            flex: 1 1 0;
            min-width: 86px;
            height: 80px;
            margin-right: 0;
            transform-origin: center bottom;
            transition: transform 0.58s cubic-bezier(0.22, 1, 0.36, 1), filter 0.58s cubic-bezier(0.22, 1, 0.36, 1);
            will-change: transform;
            &:nth-child(1) .img-box {
                background: #105D9D;
            }
            &:nth-child(2) .img-box {
                background: #1669a3;
            }
            &:nth-child(3) .img-box {
                background: #1d73a9;
            }
            &:nth-child(4) .img-box {
                background: #247dae;
            }
            &:nth-child(5) .img-box {
                background: #2a87b3;
            }
            &:nth-child(6) .img-box {
                background: #308fb8;
            }
            &:nth-child(7) .img-box {
                background: #389abe;
            }
            &:nth-child(8) .img-box {
                background: #40a6c4;
            }
            .img-box{
              background: #1669a3;
              position: relative;
              height: 100%;
              overflow: hidden;
              cursor: pointer;
              border-radius: 8px;
              box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
              transition: background-color 0.58s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.58s cubic-bezier(0.22, 1, 0.36, 1);
              .icon {
                background-image: url('@/assets/yjfxlogo1.png');
                position: absolute;
                left: 50%;
                bottom: 10px;
                width: 26px;
                height: 26px;
                margin-left: -16.5px;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }
              p{
                position: absolute;
                left: 0;
                right: 0;
                top: 10px;
                font-size: 13px;
                color: #FFF;
                line-height: 1.2;
                text-align: center;
                z-index: 2;
                padding: 0 10px;
              }
            }
          }
          .swiper-slide-active {
            height:80px;
            opacity: 1 !important;
            z-index: 4;
            transform: translateY(-7px) scale(1.07);
            filter: saturate(1.08);
            .img-box {
              box-shadow:
                0 16px 30px rgba(10, 54, 92, 0.2),
                inset 0 0 0 1px rgba(255, 255, 255, 0.18);
            }
            .img-box .icon {
                top: 18px;
                bottom: inherit;
            }
            .img-box p {
                font-weight: bold;
                bottom: 16px;
                top: inherit;
                font-size: 13px;
            }
          }
          .is-hovered {
            z-index: 5;
            transform: translateY(-10px) scale(1.12);
            filter: saturate(1.12);
            .img-box {
              box-shadow:
                0 22px 42px rgba(10, 54, 92, 0.26),
                inset 0 0 0 1px rgba(255, 255, 255, 0.18);
            }
          }
        }
      }
    }
}

@keyframes researchSlideIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
